import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col } from 'antd'
import classNames from 'classnames'

import './index.less'

const mapStateToProps = (state, ownProps) => ({
  vertical: ownProps.vertical || state.layout.mobile,
})

const FormSection = ({ children, className, vertical, label }) => (
  <Row
    gutter={vertical ? 0 : 32}
    className={classNames('form-section', className, { 'form-section--vertical': vertical })}
  >
    <Col span={vertical ? 24 : 8} className="form-section__label">
      {label}
    </Col>

    <Col span={vertical ? 24 : 16} className="form-section__content">
      {children}
    </Col>
  </Row>
)

FormSection.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  vertical: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
}

export default connect(mapStateToProps)(FormSection)
